import { useReducer } from 'react'
import { LocalizationContext } from './context'
import { initialLocalizationState, localizationReducer } from './reducers'

export default function LocalizationStateProvicer({ children }) {
	const [state, dispatch] = useReducer(localizationReducer, initialLocalizationState)

	return (
		<LocalizationContext.Provider value={[state, dispatch]}>
			{children}
		</LocalizationContext.Provider>
	)
}
